import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AlertLevel } from '@lockton-apps/shared/ui/lui';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {
  tooltip: string;
  level: AlertLevel;
}

@Component({
    selector: 'lockton-apps-alert-type',
    templateUrl: './alert-type.component.html',
    styleUrls: ['./alert-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AlertTypeComponent extends FieldType<
  FieldTypeConfig<InputProps>
> {}
